import { render } from "./CadastrarFornecedores.vue?vue&type=template&id=0aa10bb0&scoped=true"
import script from "./CadastrarFornecedores.vue?vue&type=script&lang=js"
export * from "./CadastrarFornecedores.vue?vue&type=script&lang=js"

import "./CadastrarFornecedores.vue?vue&type=style&index=0&id=0aa10bb0&scoped=true&lang=css"
import "./CadastrarFornecedores.vue?vue&type=style&index=1&id=0aa10bb0&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa10bb0"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QForm,QInput,QBtn,QTable,QImg,QTr,QTh,QTd,QField});
